










































































































import { Component, Vue } from 'vue-property-decorator'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType } from '../../../types/type'
import { Pagination } from '../../../mixins/pagination'
import { CommonModule, UserModule } from '../../../store'
import { findItemForTree, disposeSearchParamsForCM, getNameTextInOptions } from '../../../utils/toolsForCommon'
import { encode } from 'js-base64'
@Component({
  name: 'CapitalAppropriationHistory',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../../components/common/searchModule.vue'),
    'concise-card-have-title-acquiescent': () => import('../../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../../components/common/tableModule.vue'),
    'my-dialog': () => import('../../../components/common/myDialog.vue'),
    'application-container-table': () => import('../../../components/applicationContainerTable/index.vue'),
    'loading-container': () => import('../../../components/loading.vue')
  }
})
export default class CapitalAppropriationHistory extends Vue {
  public loading = false
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '申请日期',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择日期',
      show: true,
      disabled: false
    },
    {
      title: '食堂专户账号',
      key: 'account',
      type: 'input',
      value: '',
      placeholder: '请输入食堂专户账号',
      show: true,
      disabled: false
    },
    {
      title: '开户行',
      key: 'depositBank',
      type: 'input',
      value: '',
      placeholder: '请输入开户行',
      show: true,
      disabled: false
    },
    {
      title: '审批日期',
      key: 'dateIntervalForshenpiriqi',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择审批日期',
      show: true,
      disabled: false
    },
    // {
    //   title: '操作人',
    //   key: 'updatedBy',
    //   type: 'input',
    //   value: '',
    //   placeholder: '请输入操作人',
    //   show: true,
    //   disabled: false
    // }
    {
      title: '审批人',
      key: 'auditor',
      type: 'input',
      value: '',
      placeholder: '请输入审批人',
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '编号',
      key: 'uniqueCode',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '280px'
    },
    {
      title: '处理进度',
      key: 'status',
      type: 'tag',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '乡镇',
      key: 'townName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '学校',
      key: 'schoolName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '食堂专户名称',
      key: 'accountName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '食堂专户账号',
      key: 'account',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '开户行',
      key: 'depositBank',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '开户行号',
      key: 'depositBankCode',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '申请资金金额（元）',
      key: 'applyAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '申请事由',
      key: 'applyReason',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '250px'
    },
    {
      title: '申请时间',
      key: 'time',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '资金拨付时间',
      key: 'appropriateTime',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    // {
    //   title: '操作人',
    //   key: 'updatedBy',
    //   type: 'text',
    //   showStateForTableHeader: 'unilaminar',
    //   width: '200px'
    // }
    {
      title: '审批人',
      key: 'auditors',
      type: 'listForTitleValueShow',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '资金拨付证明',
      key: 'capitalAppropriationFile',
      type: 'primary',
      size: 'mini'
    },
    // {
    //   title: '确认',
    //   key: 'confirmForCapitalAppropriationHistoryOfSchool',
    //   type: 'success',
    //   size: 'mini'
    // },
    {
      title: '收据单',
      key: 'receiptForCapitalAppropriationHistoryOfSchool',
      type: 'primary',
      size: 'mini'
    }
  ]
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-bottom'></span>导出资金拨付记录列表",
      key: 'exportExcel',
      type: 'primary',
      size: '',
      canExportOutFlag: true,
      titleCopy: "<span class='el-icon-bottom'></span>导出资金拨付记录列表",
      exportResultFileName: '资金拨付记录列表.xlsx',
      exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
      exportError: '抱歉，导出失败',
      exportSuccess: '导出成功'
    }
  ]
  public dialogFlagForApplyDetail: boolean = false
  // 申请表的详细信息：
  public detailInfo: any = {}
  public loadingForApplyDetail: boolean = false
  // 枚举选项：
  // 处理进度：
  public optionsForAuditStatus: Array<OptionItemType> = [
    {
      name: '中心学校待审批',
      value: 1
    },
    {
      name: '后勤待审批',
      value: 2
    },
    {
      name: '中心学校驳回',
      value: 3
    },
    {
      name: '城投待审批',
      value: 4
    },
    {
      name: '后勤驳回',
      value: 5
    },
    {
      name: '城投待打款',
      value: 6
    },
    {
      name: '城投审核驳回',
      value: 7
    },
    {
      name: '城投转账驳回',
      value: 8
    },
    {
      name: '学校待确认',
      value: 9
    },
    {
      name: '已完成',
      value: 10
    }
  ]
  public optionsForAuditStatusForTagType: Array<OptionItemType> = [
    {
      name: '',
      value: 1
    },
    {
      name: '',
      value: 2
    },
    {
      name: 'danger',
      value: 3
    },
    {
      name: '',
      value: 4
    },
    {
      name: 'danger',
      value: 5
    },
    {
      name: '',
      value: 6
    },
    {
      name: 'danger',
      value: 7
    },
    {
      name: 'danger',
      value: 8
    },
    {
      name: 'success',
      value: 9
    },
    {
      name: 'success',
      value: 10
    }
  ]
  // 查看上传拨付证明相关：
  public dialogFlagForUploadFile :boolean = false
  public loadingForUploadFile: boolean = false
  public transferFile: string = ''
  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.getTableDataList()
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
      }
      return item
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    switch (key) {
      case 'detail':
        this.dialogFlagForApplyDetail = true
        this.detailInfo = row
        break
      case 'capitalAppropriationFile':
        this.dialogFlagForUploadFile = true
        row.file && (this.transferFile = row.file)
        break
      // case 'confirmForCapitalAppropriationHistoryOfSchool':
      //   this.operationForDisposeTheApply([row.id], 2, '要确认此资金申请记录吗？')
      //   break
      case 'receiptForCapitalAppropriationHistoryOfSchool':
        // targetId: 对应的业务id，type为1时为资金转入记录id；type为2时为资金拨付申请id
        // type: 收据类型：1：资金转入；2：资金拨付
        this.$router.push({ name: 'CapitalReceiptDetail', query: { targetId: row.id, type: '2', source: 'school' } })
        break
      case 'exportExcel':
        // 开始导出：
        this.operationForButtonOfTableHeader.forEach(async item => {
          if (item.key === 'exportExcel') {
            if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
            item.canExportOutFlag = false
            item.title = item.exportLoading
            const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
            const params = {
              ...searchParams,
              schoolIds: [this.userInfo.organizationId],
              role: 'SCHOOL',
              completed: 1
            }
            const result = await (this as any).$http.capitalAppExport(params)
            if (result.status !== 200) {
              this.$message.error(item.exportError)
              item.canExportOutFlag = true
              item.title = item.titleCopy
              return false
            };
            const blob = new Blob([result.data], {
              type: 'application/vnd.ms-excel'
            })
            const objectUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = objectUrl
            a.download = this.orgName + '--' + item.exportResultFileName
            a.click()
            // 释放临时的对象url
            window.URL.revokeObjectURL(objectUrl)
            this.$message.success(item.exportSuccess)
            item.canExportOutFlag = true
            item.title = item.titleCopy
          }
        })
        break
    }
  }

  // 处理申请 ：
  // operationForDisposeTheApply (ids: Array<string | number>, operation: number, confirmText: string) {
  //   let messageText = ''
  //   switch (operation) {
  //     case 2:
  //       messageText = '操作成功，已确认'
  //       break
  //   }
  //   this.$confirm(confirmText, '提示', {
  //     confirmButtonText: `确定`,
  //     cancelButtonText: `取消`,
  //     type: 'warning'
  //   }).then(async () => {
  //     let { data: result } = await (this as any).$http.capitalAppApprove({
  //       ids,
  //       operation,
  //       role: 'SCHOOL'
  //     })
  //     if (result.code !== 200) return this.$message.error(result.msg)
  //     this.$message.success(messageText)
  //     this.getTableDataList()
  //   }).catch(() => {})
  // }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams,
        schoolIds: [this.userInfo.organizationId],
        role: 'SCHOOL',
        completed: 1
      }
      const { data: result } = await (this as any).$http.capitalAppQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item['tagType'] = getNameTextInOptions(this.optionsForAuditStatusForTagType, item.status)
        item.status = getNameTextInOptions(this.optionsForAuditStatus, item.status)
        item.auditors = item.auditors || []
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    if (!v) return this.$message.error('抱歉，没有可预览的文件哦！')
    this.dialogVisibleForPreviewFile = true
    let previewUrl = _that.$previewURL + '/onlinePreview?url=' + encodeURIComponent(encode(v))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }
}
